// extracted by css-extract-rspack-plugin
export default {"SecondaryCTALink":"MPL9e"};